import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Button, Input, Table } from 'antd';

const { Search } = Input;

@inject('FnbAdditionalItemStore')
@observer
class FnbAdditionalItemSearchModalPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            searchText: '',
            searchedColumn: ''
        }
    }

    componentDidMount() {
    }

    getColumns = () => {
        return [
            {
                title: 'In Room Dining',
                dataIndex: 'taskName',
                key: 'taskName',
                width: '40%'
            },
            {
                title: 'Category',
                dataIndex: 'categoryName',
                key: 'parentName',
                width: '40%'
            },
            {
                title: 'Action',
                dataIndex: 'taskId',
                key: 'action',
                width: '10%',
                render: taskId => (
                    <span>
                        <Button onClick={() => this.selectItemOnClick(taskId)} type='primary'>
                            Select
                        </Button>
                    </span>
                ),
            },
        ]
    }

    // ON CHANGE

    itemOnChange = e => {
        this.props.FnbAdditionalItemStore.setItemSearchValue(e.target.value);
        this.props.FnbAdditionalItemStore.searchItem();
    }

    // ON CLICK

    selectItemOnClick = taskId => {
        this.props.FnbAdditionalItemStore.searchItemSelected(taskId);
        this.props.FnbAdditionalItemStore.setShowFnbAdditinalItemSearchModal(false);
    }

    render() {
        const {
            lastChildItemFilter,
            itemSearchValue
        } = this.props.FnbAdditionalItemStore;

        return (
            <React.Fragment>
                <Search style={{ marginBottom: 10 }} placeholder='Search Retail' value={itemSearchValue} onChange={this.itemOnChange} />
                <Table columns={this.getColumns()} dataSource={lastChildItemFilter} />
            </React.Fragment>
        )
    }
}

export default FnbAdditionalItemSearchModalPage;